import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  AddIdpDomainMutation,
  AddIdpDomainMutationVariables,
} from '@investigator/shared/generated/graphql';

export const ADD_IDP_DOMAIN = gql`
  mutation addIdpDomain($idp_domain: String!) {
    addIdpDomain(idp_domain: $idp_domain) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;

export const useAddIdpDomain = (
  options?: MutationHookOptions<
    AddIdpDomainMutation,
    AddIdpDomainMutationVariables
  >,
) => {
  return useMutation<AddIdpDomainMutation, AddIdpDomainMutationVariables>(
    ADD_IDP_DOMAIN,
    options,
  );
};
